module.exports = __webpack_public_path__ + "assets/img/1-1.427d6ba5.jpg";